// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NavPane_wrapper__1Qtvy","list":"NavPane_list__2Qbgc","item":"NavPane_item__h61_k","link":"NavPane_link__19i0O","active":"NavPane_active__1aCmc"};